<template>
    <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false"
               :close-on-press-escape="false">
        <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()"
                 :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
            <el-form-item label="文件名" prop="name">
                <el-input v-model="dataForm.name" placeholder="文件名"></el-input>
            </el-form-item>
            <el-form-item label="文件" prop="fileUrl">
                <el-upload :class="{hide:hideUpload}" :action="this.uploadUrl"
                           :file-list="mainFileList"
                           list-type="picture"
                           :before-upload="beforeAvatarUpload"
                           :on-success="handleAvatarSuccess"
                           :on-remove="handleRemove"
                           :limit="1">
                    <i class="el-icon-plus"></i>
                </el-upload>
            </el-form-item>
            <el-form-item label="标题" prop="title">
                <el-input v-model="dataForm.title" placeholder="标题"></el-input>
            </el-form-item>
            <el-form-item prop="detailDesc" label="内容">
                <!-- 富文本编辑器, 容器 -->
                <div id="J_quillEditor" style="height: 600px;"></div>
                <!-- 自定义上传图片功能 (使用element upload组件) -->
                <el-upload :action="uploadUrl" :show-file-list="false" :before-upload="uploadBeforeUploadHandle"
                           :on-success="uploadSuccessHandle" style="display: none;">
                    <el-button ref="uploadBtn" type="primary" size="small">{{ $t('upload.button') }}</el-button>
                </el-upload>
            </el-form-item>
        </el-form>
        <template slot="footer">
            <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
            <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
        </template>
    </el-dialog>
</template>

<script>
    import Cookies from 'js-cookie'
    import debounce from 'lodash/debounce'
    import Quill from 'quill'
    import 'quill/dist/quill.snow.css'


    export default {
        data() {
            return {
                visible: false,
                booleanPublishStatus: true,
                booleanRecommandStatus: true,
                dataForm: {
                    id: '',
                    name: '',
                    fileUrl: '',
                    title: '',
                    creator: '',
                    detailDesc: '',
                    createDate: '',
                    updateDate: ''
                },
                //图片上传
                headers: {
                    token: this.cookie.get('token')
                },
                dialogImageUrl: '',
                dialogVisible: false,
                hideUpload: false,
                imgsHideUpload: false,
                mainFileList: [],
                imgsFileList: [],
                uploadUrl: '',
                //富文本数据
                quillEditor: null,
                quillEditorToolbarOptions: [
                    ['bold', 'italic', 'underline', 'strike'],
                    ['blockquote', 'code-block', 'image'],
                    [{
                        'header': 1
                    }, {
                        'header': 2
                    }],
                    [{
                        'list': 'ordered'
                    }, {
                        'list': 'bullet'
                    }],
                    [{
                        'script': 'sub'
                    }, {
                        'script': 'super'
                    }],
                    [{
                        'indent': '-1'
                    }, {
                        'indent': '+1'
                    }],
                    [{
                        'direction': 'rtl'
                    }],
                    [{
                        'size': ['small', false, 'large', 'huge']
                    }],
                    [{
                        'header': [1, 2, 3, 4, 5, 6, false]
                    }],
                    [{
                        'color': []
                    }, {
                        'background': []
                    }],
                    [{
                        'font': []
                    }],
                    [{
                        'align': []
                    }],
                    ['clean']
                ],
            }
        },
        computed: {
            dataRule() {
                return {
                    name: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    ],
                    fileUrl: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    ],
                    updateDate: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    ]
                }
            }
        },
        methods: {
            init() {
                this.visible = true
                this.$nextTick(() => {
                    //清空数据
                    this.$refs['dataForm'].resetFields()
                    this.hideUpload = false
                    //富文本
                    if (this.quillEditor) { //有值清空数据
                        this.quillEditor.deleteText(0, this.quillEditor.getLength())
                        // this.quillEditorHandle()

                    } else { //没值，初始化
                        this.quillEditorHandle()
                    }

                    if (this.dataForm.id) {
                        this.getInfo()
                    }
                })
            },
            // 获取信息
            getInfo() {
                this.$http.get(`/ums/document/${this.dataForm.id}`).then(({data: res}) => {
                    if (res.code !== 0) {
                        return this.$message.error(res.msg)
                    }
                    if (res.code !== 0) {
                        return this.$message.error(res.msg)
                    }
                    console.log(res.data)
                    this.dataForm = {
                        ...this.dataForm,
                        ...res.data
                    }
                    this.mainFileList = [{
                        name: '已上传文件',
                        url: this.dataForm.fileUrl
                    }]
                    //富文本
                    console.info(this.dataForm.detailDesc)
                    this.quillEditor.root.innerHTML = this.dataForm.detailDesc

                }).catch(() => {
                })

            },
            // 表单提交
            dataFormSubmitHandle: debounce(function () {
                this.$refs['dataForm'].validate((valid) => {
                    if (!valid) {
                        return false
                    }
                    this.$http[!this.dataForm.id ? 'post' : 'put']('/ums/document/', this.dataForm).then(({data: res}) => {
                        if (res.code !== 0) {
                            return this.$message.error(res.msg)
                        }
                        this.$message({
                            message: this.$t('prompt.success'),
                            type: 'success',
                            duration: 500,
                            onClose: () => {
                                this.visible = false
                                this.$emit('refreshDataList')
                            }
                        })
                        this.dataForm.fileUrl = ""
                    }).catch(() => {
                    })
                })
            }, 1000, {'leading': true, 'trailing': false}),
            //文件上传
            beforeAvatarUpload(file) {
                const isLt2M = file.size / 1024 / 1024 < 2;

                if (!isLt2M) {
                    this.$message.error('图片大小不能超过 2MB!');
                }
                return isLt2M;
            },
            handleAvatarSuccess(res, file, fileList) {
                // this.dataForm.mainPicture = URL.createObjectURL(file.raw);
                this.dataForm.fileUrl = res.data.src
                this.hideUpload = fileList.length >= 1
            },
            handleRemove(file, fileList) {
                this.hideUpload = fileList.length >= 1;
            },

            ImgshandleAvatarSuccess(res, file, fileList) {
                this.dataForm.pictures.push(res.data)
                this.imgsHideUpload = fileList.length >= 5;
            },
            ImgshandleRemove(file, fileList) {
                //删除数组中的某个元素
                this.dataForm.pictures.forEach((item, index) => {
                    console.log(file)
                    if (item == file.url) {
                        this.dataForm.pictures.splice(index, 1)
                    }
                })
                this.imgsHideUpload = fileList.length >= 5;
            },
            handlePictureCardPreview(file) {
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },

            addAttribute() {
                this.dataForm.skuList.push({
                    // name: this.attributeName,
                    skuValue: this.skuValue,
                    skuPrice: this.skuPrice,
                    skuIntegration: this.skuIntegration,
                    skuStock: this.skuStock

                })
                console.log(this.dataForm.skuList)
                this.skuPrice = '',
                    this.skuValue = '',
                    this.skuIntegration = '',
                    this.skuStock = ''
            },
            addAttributeValue(index) {
                var attributeValue = this.$refs[`value${index}`][0].value
                this.dataForm.skuList[index].value.push(attributeValue)
            },
            deleteAttribute(index) {
                this.dataForm.skuList.splice(index, 1)
            },
            deleteAttributeValue(index, valueIndex) {
                this.dataForm.skuList[index].value.splice(valueIndex)
            },

            // 富文本编辑器
            quillEditorHandle() {
                this.quillEditor = new Quill('#J_quillEditor', {
                    modules: {
                        toolbar: this.quillEditorToolbarOptions
                    },
                    theme: 'snow'
                })
                // 自定义上传图片功能 (使用element upload组件)
                this.uploadUrl = `${window.SITE_CONFIG['apiURL']}/sys/oss/upload?token=${Cookies.get('token')}`
                this.quillEditor.getModule('toolbar').addHandler('image', () => {
                    this.$refs.uploadBtn.$el.click()
                })
                // 监听内容变化，动态赋值
                this.quillEditor.on('text-change', () => {
                    this.dataForm.detailDesc = this.quillEditor.root.innerHTML
                })
            },
            // 上传图片之前
            uploadBeforeUploadHandle(file) {
                if (file.type !== 'image/jpg' && file.type !== 'image/jpeg' && file.type !== 'image/png' && file.type !==
                    'image/gif') {
                    this.$message.error('只支持jpg、png、gif格式的图片！')
                    return false
                }
            },
            // 上传图片成功
            uploadSuccessHandle(res, file, fileList) {
                if (res.code !== 0) {
                    return this.$message.error(res.msg)
                }
                this.quillEditor.insertEmbed(this.quillEditor.getSelection().index, 'image', res.data.src)
            },
        }
    }
</script>
<style>
    .hide .el-upload--picture-card {
        display: none;
    }

    .box-card {
        width: 480px;
    }
</style>
